import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2295507c&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=2295507c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295507c",
  null
  
)

export default component.exports